<div class="main container-fluid">
  <div class="page-header">
    <h1>{{LOCALIZATION.savedSearches}}</h1>
  </div>
  <div class="row">
    <!-- // Filter panel -->
    <div class="col-md-3">
      <div class="panel panel-default">
          <div class="panel-body" >
              <span class="lead">{{LOCALIZATION.filterSearches}}</span>
              <hr>
              <form>
                  <div class="bottom-spacing">
                      <label for="searchName">{{LOCALIZATION.name}}</label>
                      <div>
                      	<input id="searchName" name="searchName"  
                      		class="form-control" type="text" 
                      		[(ngModel)]="filters.searchName"/>
                      	</div>
                  </div>              
                  <div class="bottom-spacing">
                      <label for="searchDate">{{LOCALIZATION.created}}</label>
                      <div>
						<input id="searchDate" name="searchDate"
						    class="form-control flatpickr" type="text" 
						    [(ngModel)]="filters.dateRange"
						    placeholder="{{LOCALIZATION.downloadDatePlaceholder}}" 
						    (focus)="openDatePicker('downloadDate')"/>
						<i class="fas fa-calendar-alt pointMe" style="float:right;margin-top:4px;" title="{{LOCALIZATION.openCalendar}}"
   							(click)="openDatePicker('searchDate')"></i>                       
                      </div>
                  </div>
                  <div class="bottom-spacing" *ngIf="mode==='public' && showCreator">
                      <label for="username_input">{{LOCALIZATION.creator}}</label>
                      <div class="group-container">
                          <div *ngFor="let username of filters.usernames; let i = index;" class="criteriaList label">
                            <div style="flex: 3; font-size: 12px;">
                              {{username}}
                            </div>
                            <i (click)="removeUsername(i)" class="pointMe removeTag glyphicon glyphicon-remove"></i>
                          </div>
                      </div>
                      <input id="userName" name="userName"
                        class="form-control" type="text" 
                      	[(ngModel)]="filters.username_input" 
                      	placeholder="Enter username filter(s)..." 
                      	(keydown.enter)="submitUsername()"/>
                  </div>
                  <div class="bottom-spacing">
                      <label for="searchStatus">{{LOCALIZATION.status}}</label>
                      <div>
						<select class="form-control" name="searchStatus" id="searchStatus" [(ngModel)]="filters.searchStatus">
							<option value=""></option>
							<option value="Favorite">{{LOCALIZATION.favorite}}</option>
							<option value="Subscribed">{{LOCALIZATION.subscribed}}</option>
						</select>                      	
                      </div>
                  </div>                  
                  <div>
                       <div class="primary-controls">
                           <button class="btn btn-default btn-md delete" (click)="clear()">
                           		<span aria-hidden="true"></span> {{LOCALIZATION.clear}} 
                           </button>
                           <button class="btn btn-primary btn-md submit-button submit-button-sm" (click)="filter()">
                           		<span class="fas fa-filter" aria-hidden="true"></span> {{LOCALIZATION.filter}} 
                           </button>
                       </div>                      
                  </div>
              </form>
          </div>
      </div>
  </div>
  <!-- // END filter panel -->
  <div class="col-md-9">
    <!-- .................................................My Saved Searches........................................ -->  
	<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" (navChange)="onTabChange($event)" class="nav nav-tabs nav-justified">
	  <li class="nav-item" [ngbNavItem]="1" *ngIf="userPermissions['ROLE_NOTIFICATION_MANAGEMENT'] || userPermissions['ROLE_NOTIFICATION_CREATE']">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.savedSearches }}
	    </a>	    
	    <ng-template ngbNavContent>
          <br>
          <div class="col-sm-12 col-md-12">
              <div class="clearfix">
                <div *ngIf="searches && searches.length > 0" class='pull-right primary-controls'>
                  <button *ngIf="selectedSearches.canSubscribe" class="btn btn-circle btn-accent" title="{{LOCALIZATION.subscribe}}" (click)="massSubscribeToSearches()"><i class="fa fa-rss" aria-hidden="true"></i></button>
                  <button *ngIf="selectedSearches.canUnsubscribe" class="btn btn-circle btn-danger background-red" title="{{LOCALIZATION.unsubscribe}}" (click)="massUnsubscribeFromSearches()"><i class="fa fa-rss" aria-hidden="true"></i></button>
				  <button *ngIf="selectedSearches.canUnfavorite" class="btn btn-circle btn-danger background-red" title="{{LOCALIZATION.unfavorite}}" (click)="massUnfavoriteSearches()"><i class="fa fa-heart" aria-hidden="true"></i></button>                  
                  <button class="btn btn-primary btn-circle" (click)="loadSavedSearches(1)" title="{{LOCALIZATION.refresh}}"><i class="fas fa-sync"></i></button>
                </div>
              </div>
              <div *ngIf="searches && searches.length == 0"><i>{{LOCALIZATION.resultsEmpty}}</i></div>
              <table *ngIf="searches && searches.length > 0" class='table table-condensed table-no-border' style="table-layout:fixed">
                <thead>
                <tr>
                  <th class="sortable" style="width:{{isMobile ? 60 : 40}}%" (click)="sortingChanged('name')" title="{{LOCALIZATION.sortBy}} {{LOCALIZATION.name}}">{{LOCALIZATION.name}}</th>
                  <th class="sortable hidden-xs" (click)="sortingChanged('created')" title="{{LOCALIZATION.sortBy}} {{LOCALIZATION.created}}"><span class="hidden-xs">{{LOCALIZATION.created}}</span></th>
                  <th class="sortable" style="width:{{isMobile ? 20 : 10}}%" (click)="sortingChanged('isPublic')" title="{{LOCALIZATION.sortBy}} {{LOCALIZATION.public}}">{{LOCALIZATION.public}}</th>
                  <th class="text-center hidden-xs"><span class="hidden-xs">{{LOCALIZATION.status}}</span></th>
                  <th class="text-center"><span class="hidden-xs">{{LOCALIZATION.actions}}</span></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor='let search of searches' class="parent-row">
    				<td class="inner" [attr.colspan]="isMobile ? 3 : 5">
      					<table class="table table-condensed inner-table">
        					<tr>
			                  <td style="width:{{isMobile ? 60 : 40}}%">
			                    <label class="control control--checkbox">
			                      <input type="checkbox" (click)="toggleSearchId(search.id)"/>
			                      <div class="control__indicator"></div>
                                  <p (click)="executeSearch(search)" style="font-size:14px; font-weight:400; margin-left:5px" class="truncate pointMe link" title="{{LOCALIZATION.searchClick}}">{{search.name}}</p>
			                    </label>
			                  </td>
			                  <td class="hidden-xs"><p class="hidden-xs truncate" title="{{search.created}}">{{search.created}}</p></td>
			                  <td style="width:{{isMobile ? 20 : 10}}%">
			                    <div *ngIf="!search.isFavorite" class="toggle-switch pull-left" title="Make this search public">
			                      <input id="public_switch_{{search.id}}" name="public_switch_{{search.id}}"
			                        type="checkbox"
			                      	class="toggle-switch-toggle toggle-switch-toggle-round" 
			                      	[ngClass]="{'disabled': !userPermissions['ROLE_PUBLISH_SAVED_SEARCH']}"
			                      	(change)="updatePublic(search)" 
			                      	[(ngModel)]="search.isPublic"
			                      	[disabled]="!userPermissions['ROLE_PUBLISH_SAVED_SEARCH'] || search.updating">
			                      <label for="public_switch_{{search.id}}"></label>
			                    </div>
			                  </td>
			                  <td class="text-center truncate hidden-xs">
			                    <div class="hidden-xs"><span *ngIf="search.subscriptionId" class="badge">{{LOCALIZATION.subscribed}}</span></div>
			                    <div class="hidden-xs"><span *ngIf="search.isFavorite" class="badge">{{LOCALIZATION.favorite}}</span></div>
			                  </td>
			                  <td class="text-center" style="padding: 0;">
			                    <div class="dropdown" id="saved-search-operations-div" ngbDropdown>
								  <button ngbDropdownToggle
									  type="button"
									  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
									  aria-haspopup="true"
									  aria-expanded="false"
									  [attr.aria-label]="LOCALIZATION.actions"
									  title="{{LOCALIZATION.actions}}"
									  style="border: 0; background: transparent;">
										<i class="nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
								  </button>								  
			                      <ul class="dropdown-menu custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
			                        <li role="menuitem"><a title="{{LOCALIZATION.searchClick}}" (click)="executeSearch(search)" class="pointMe accent-color">{{LOCALIZATION.run}}</a></li>
			                        <li role="menuitem" *ngIf="!search.isFavorite"><a title="{{LOCALIZATION.viewEdit}}" (click)="viewSearch(search,true)" class="pointMe accent-color">{{LOCALIZATION.viewEdit}}</a></li>
			                        <li role="menuitem" *ngIf="search.isFavorite"><a title="{{LOCALIZATION.view}}" (click)="viewSearch(search,false)" class="pointMe accent-color">{{LOCALIZATION.view}}</a></li>
			                        <li role="menuitem" *ngIf="!search.subscriptionId"><a (click)="subscribeToSearch(search.id)" title="{{LOCALIZATION.subscribe}}" class="pointMe accent-color">{{LOCALIZATION.subscribe}}</a></li>
			                        <li role="menuitem"><a (click)="openRSS(search)" title="{{LOCALIZATION.viewRSS}}" class="pointMe accent-color">{{LOCALIZATION.viewRSS}}</a>
			                        </li>
			                        <li class="divider"></li>
			                        <li role="menuitem" *ngIf="!search.isFavorite"><a title="{{LOCALIZATION.deleteItem}}" (click)="onDeleteSearch(search.id)" class="pointMe text-red">{{LOCALIZATION.deleteItem}}</a></li>
			                        <li role="menuitem" *ngIf="search.isFavorite"><a (click)="unfavoriteASearch(search.id)" title="Remove this favorite" class="pointMe text-red">{{LOCALIZATION.unfavorite}}</a></li>
			                        <li role="menuitem" *ngIf="search.subscriptionId"><a (click)="unsubscribeFromSearch(search.id)" title="{{LOCALIZATION.unsubscribe}}" class="pointMe text-red">{{LOCALIZATION.unsubscribe}}</a></li>
			                      </ul>
			                    </div>
			                  </td>
			        	</tr>
			        	<tr *ngIf="search.description">
			         	 	<td [attr.colspan]="isMobile ? 3 : 5"><div class="long-block">{{search.description}}</div></td>
			        	</tr>
			      	</table>
			    </td>
                </tr>
                </tbody>
              </table>
          </div>
		    <div class="tab-pagination-container">
				<div class="text-center">
					  <ngb-pagination class="pagination custom-page pagination-sm"
					    [(page)]="pagination.page" 
					    [pageSize]="pagination.elementsPerPage"
					    [collectionSize]="pagination.totalElements" 
					    (pageChange)="pagination.pageChanged($event)"
					    [maxSize]="5"
					    [boundaryLinks]="true"
					    previousText="&#xf053;"
					    nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">
					  </ngb-pagination>					
				</div>
            </div>
	    </ng-template>
	  </li>
       <!-- .................................................Public Searches........................................ -->
	  <li class="nav-item" [ngbNavItem]="2" *ngIf="userPermissions['ROLE_NOTIFICATION_VIEW'] || userPermissions['ROLE_NOTIFICATION_MANAGEMENT']">
	    <a class="nav-link" ngbNavLink>
	      {{ LOCALIZATION.savedSearchesPublic }}
	    </a>	    
	    <ng-template ngbNavContent>           
          <br>
          <div class="col-sm-12 col-md-12">
              <div class="clearfix">
                <div *ngIf="searches && searches.length > 0" class='pull-right primary-controls'>
                  <button *ngIf="selectedSearches.canSubscribe && selectedSearches.selected.length > 0 && userPermissions['ROLE_NOTIFICATION_SUBSCRIBE']" class="btn btn-circle btn-accent" title="{{LOCALIZATION.subscribe}}" (click)="massSubscribeToSearches()"><i class="fa fa-rss" aria-hidden="true"></i></button>
                  <button *ngIf="selectedSearches.canUnsubscribe" class="btn btn-circle btn-danger background-red" title="{{LOCALIZATION.unsubscribe}}" (click)="massUnsubscribeFromSearches()"><i class="fa fa-rss" aria-hidden="true"></i></button>
                  <button *ngIf="selectedSearches.canFavorite && userPermissions['ROLE_NOTIFICATION_CREATE']" class="btn btn-circle btn-accent" title="{{LOCALIZATION.favorite}}" (click)="massFavoriteSearches()"><i class="fa fa-heart" aria-hidden="true"></i></button>
                  <button *ngIf="selectedSearches.canUnfavorite" class="btn btn-circle btn-danger background-red" title="{{LOCALIZATION.unfavorite}}" (click)="massUnfavoriteSearches()"><i class="fa fa-heart" aria-hidden="true"></i></button>
                  <button class="btn btn-primary btn-circle" (click)="loadPublicSearches(1)" title="{{LOCALIZATION.refresh}}"><i class="fas fa-sync"></i></button>                  
                </div>
              </div>
              <div *ngIf="!searches || searches.length == 0"> <i>{{LOCALIZATION.resultsEmpty}}</i></div>
              <table *ngIf="searches && searches.length > 0" class='table table-condensed table-no-border' style="table-layout:fixed">
                <thead>
                <tr>
                  <th class="sortable" style="width:{{isMobile ? 65 : 50}}%" (click)="sortingChanged('name')" title="{{LOCALIZATION.sortBy}} {{LOCALIZATION.name}}">{{LOCALIZATION.name}}</th>
                  <th class="sortable hidden-xs" (click)="sortingChanged('created')" title="{{LOCALIZATION.sortBy}} {{LOCALIZATION.created}}"><span class="hidden-xs">{{LOCALIZATION.created}}</span></th>
                  <th class="hidden-xs" *ngIf="showCreator"><span class="hidden-xs">{{LOCALIZATION.creator}}</span></th>
                  <th class="text-center hidden-xs"><span class="hidden-xs">{{LOCALIZATION.status}}</span></th>
                  <th class="text-center"><span class="hidden-xs">{{LOCALIZATION.actions}}</span></th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor='let search of searches' class="parent-row">
    				<td class="inner" [attr.colspan]="isMobile ? 2 : (showCreator ? 5 : 4)">
      					<table class="table table-condensed inner-table">
        					<tr>
			                  <td style="width:{{isMobile ? 65 : 50}}%">
			                    <label class="control control--checkbox">
			                      <input type="checkbox" (click)="toggleSearchId(search.id)"/>
			                      <div class="control__indicator"></div>
			                      <p (click)="executeSearch(search)" style="font-size:14px;font-weight:400;margin-left:5px" class="truncate pointMe link" title="{{LOCALIZATION.searchClick}}">{{search.name}}</p>
			                    </label>
			                  </td>
			                  <td class="hidden-xs"><p class="hidden-xs truncate" title="{{search.created}}">{{search.created}}</p></td>
			                  <td class="hidden-xs" *ngIf="showCreator"><p class="hidden-xs truncate" title="{{search.userName}}">{{search.userName}}</p></td>
			                  <td class="text-center truncate hidden-xs">
			                    <div class="hidden-xs"><span *ngIf="search.subscriptionId" class="badge">{{LOCALIZATION.subscribed}}</span></div>
			                    <div class="hidden-xs"><span *ngIf="search.isFavorite" class="badge">{{LOCALIZATION.favorite}}</span></div>
			                  </td>
			                  <td class="text-center" style="padding: 0;">
			                    <div class="dropdown" id="saved-public-search-operations-div" ngbDropdown>
								  <button ngbDropdownToggle
									  type="button"
									  class="dropdown-toggle dropdown-toggle-fixed btn-xs btn-menu center-block"
									  aria-haspopup="true"
									  aria-expanded="false"
									  [attr.aria-label]="LOCALIZATION.actions"
									  title="{{LOCALIZATION.actions}}"
									  style="border: 0; background: transparent;">
										<i class="nav-icon fa fa-ellipsis-v" aria-hidden="true"></i>
								  </button>								  
			                      <ul class="dropdown-menu custom-drop" ngbDropdownMenu [attr.aria-label]="LOCALIZATION.optionsList" role="menu">
			                        <li role="menuitem"><a title="{{LOCALIZATION.searchClick}}" (click)="executeSearch(search)" class="pointMe accent-color">{{LOCALIZATION.run}}</a></li>
			                        <li role="menuitem" *ngIf="!search.subscriptionId"><a (click)="viewSearch(search,false)" title="{{LOCALIZATION.view}}" class="pointMe accent-color">{{LOCALIZATION.view}}</a>
			                        <li role="menuitem" *ngIf="search.subscriptionId"><a (click)="viewSearch(search,false)" title="{{LOCALIZATION.viewEdit}}" class="pointMe accent-color">{{LOCALIZATION.viewEdit}}</a>
			                        <li role="menuitem" *ngIf="!search.subscriptionId && userPermissions['ROLE_NOTIFICATION_SUBSCRIBE']"><a (click)="subscribeToSearch(search.id)" title="{{LOCALIZATION.subscribe}}" class="pointMe accent-color">{{LOCALIZATION.subscribe}}</a></li>
			                        <li role="menuitem" *ngIf="userPermissions['ROLE_NOTIFICATION_CREATE'] && !search.isFavorite"><a (click)="favoriteASearch(search.id)" title="Favorite this search and add it to your searches" class="pointMe accent-color">{{LOCALIZATION.favorite}}</a></li>
			                        <li role="menuitem"><a (click)="openRSS(search)" title="{{LOCALIZATION.viewRSS}}" class="pointMe accent-color">{{LOCALIZATION.viewRSS}}</a></li>
			                        <li class="divider"></li>
			                        <li role="menuitem" *ngIf="search.isFavorite"><a (click)="unfavoriteASearch(search.id)" title="Remove this favorite" class="pointMe text-red">{{LOCALIZATION.unfavorite}}</a></li>
			                        <li role="menuitem" *ngIf="search.subscriptionId"><a (click)="unsubscribeFromSearch(search.id)" title="{{LOCALIZATION.deleteItem}}" class="pointMe text-red">{{LOCALIZATION.unsubscribe}}</a></li>
			                      </ul>
			                    </div>
			                  </td>
				        	</tr>
				        	<tr *ngIf="search.description">
				         	 	<td [attr.colspan]="isMobile ? 2 : (showCreator ? 5 : 4)"><div class="long-block">{{search.description}}</div></td>
				        	</tr>
			      	</table>
			    </td>
                </tr>
                </tbody>
              </table>
          </div>
		    <div class="tab-pagination-container">
				<div class="text-center">
					  <ngb-pagination class="pagination custom-page pagination-sm"
					    [(page)]="pagination.page" 
					    [pageSize]="pagination.elementsPerPage"
					    [collectionSize]="pagination.totalElements" 
					    (pageChange)="pagination.pageChanged($event)"
					    [maxSize]="5"
					    [boundaryLinks]="true"
					    previousText="&#xf053;"
					    nextText="&#xf054;"
					    firstText="&#xf053;&#xf053;"
					    lastText="&#xf054;&#xf054;">
					  </ngb-pagination>					
				</div>
            </div>
	    </ng-template>	    
	  </li>
	</ul>
	<div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
